import React from 'react';
import { Table } from 'semantic-ui-react';
import SimpleCell from '@/components/table/SimpleCell';

const DatasetMetricsRow = ({
  total, totalApproved, totalDenied, totalTransfers,
}) => (
  <Table.Row>
    <SimpleCell content={total} textAlign="right" />
    <SimpleCell content={totalApproved} textAlign="right" />
    <SimpleCell content={totalDenied} textAlign="right" />
    <SimpleCell content={totalTransfers} textAlign="right" />
  </Table.Row>
);

export default DatasetMetricsRow;
